module.exports = __webpack_public_path__ + "static/GFX-ebook-hover-ef4a836b383c03b264dc5f26460da34d.png";